import httpClient from './httpClient';

const client = {
    getContact(id) {
        return httpClient.get(`/api/adv/mission/${id}/contact`);
    },
}

export default client;